import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Select } from '.';
import CSSModules from 'react-css-modules';
import style from './time-field.scss';

@CSSModules(style)
export default class TimeField extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    formFieldName: PropTypes.string,
    getFormValue: PropTypes.func
  }

  get innerValue() {
    const value = this.value;
    let hour = 0, minutes = 0, period = 1;

    if (value && typeof(value) === 'number') {
      period = value === 86400 || value < 43200 ? 1 : 2;
      hour = parseInt((value % 43200) / (60 * 60)) % 12;
      minutes = parseInt((value % 43200) / 60) % 60;
    }

    return {
      hour,
      minutes,
      period
    }
  }

  handleChange(type) {
    return value => {
      const innerValue = this.innerValue;
      innerValue[type] = Number(value);

      const { hour, minutes, period } = innerValue;
      let val = hour * 60 * 60 + minutes * 60 + (period === 2 ? 43200 : 0);

      if (val === 0 && this.props.secondary) {
        val = 86400;
      }

      if (this.props.onChange) this.props.onChange(val);
      if (this.context.onChange) this.context.onChange(this.name, val);
    }
  }

  get name() {
    return this.props.name || this.context.formFieldName;
  }

  get value() {
    return this.props.value || this.context.getFormValue(this.name);
  }

  render() {
    const { hour, minutes, period } = this.innerValue;

    return (
      <span styleName="root">
        <span>
          <Input
            maxLength={2}
            onChange={::this.handleChange('hour')}
            value={String(hour)}
          />
        </span>
        <span styleName="break" />
        <span>
          <Input
            maxLength={2}
            onChange={::this.handleChange('minutes')}
            value={String(minutes)}
          />
        </span>
        <span styleName="break" />
        <span styleName="select">
          <Select
            onChange={::this.handleChange('period')}
            options={[
              { label: 'AM', value: 1 },
              { label: 'PM', value: 2 }
            ]}
            value={period}
          />
        </span>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/time-field.js